<template>
    <div>
      <div class="relative mt-4">
        <new-table-lite
          class="admin-table summary Totals"
          :is-loading="table.isLoading"
          :is-static-mode="true"
          :is-slot-mode='true'
          :columns="selectColumnType()"
          :rows="table.rows"
          :total="table.totalRecordCount"
          :sortable="table.sortable"
          @is-finished="table.isLoading = false"
          :page-size='table.pagesize'
          :pageOptions='table.pageOptions'
          :has-checkbox="false"
          :is-hide-paging="false"
          :pageSizeChangeLabel="'pageSizeChangeLabel'"
          :messages="{
            pagingInfo: 'Total: {2}',
            pageSizeChangeLabel: 'Items per Page',
            gotoPageLabel: '',
            noDataAvailable: 'No records found!',
          }"
        >
        <!-- filter -->
        <template v-slot:filter>
          <tr v-if="includeLot" class="vtl-thead-tr z-20">
            <td class="vtl-tbody-td">
              <span>Totals</span>
            </td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td">{{ sumPayload.stock }}</td>
            <td class="vtl-tbody-td">{{ sumPayload.batchStock }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.batchTotalCost) }}</td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.sale_price) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.profitMargin) }}</td>
            <td class="vtl-tbody-td">{{sumPayload.profit_margin_percentage}}</td>
            <td class="vtl-tbody-td">{{displayPriceFormat(sumPayload.markup) }}</td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
          </tr>
          <tr v-else class="vtl-thead-tr z-20">
            <td class="vtl-tbody-td">
              <span>Totals</span>
            </td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td">{{ sumPayload.stock }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalStockCost) }}</td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.sale_price) }}</td>
            <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.profitMargin) }}</td>
            <td class="vtl-tbody-td">{{sumPayload.profit_margin_percentage}}</td>
            <td class="vtl-tbody-td">{{displayPriceFormat(sumPayload.markup) }}</td>
            <td class="vtl-tbody-td"></td>
            <td class="vtl-tbody-td"></td>
          </tr>
        </template>

        <template v-slot:location="data">
          <span v-if="data.value.productPricing?.locations?.name">{{data.value.productPricing.locations.name}}</span>
          <span v-else-if="data.value.inventorySnapshots?.[0]?.location?.name">{{data.value.inventorySnapshots?.[0]?.location?.name}}</span>
          <span v-else></span>
        </template>
        <template v-slot:Name="data">
          <span v-if="data.value.name">{{data.value.name}}</span>
          <span v-else></span>
        </template>
        <template v-slot:brand="data">
          <span v-if="data.value.brand?.name">{{data.value.brand?.name}}</span>
          <span v-else></span>
        </template>
        <template v-slot:productLot="data">
          <span v-if="data.value.batchUploadDetails?.[0]?.batch_lot">{{data.value.batchUploadDetails?.[0]?.batch_lot}}</span>
          <span v-else>--</span>
        </template>
        <template v-slot:stock="data">
          <span>{{data.value.stock ? data.value.stock : 0}}</span>
        </template>
        <template v-slot:batchStock="data">
          <span>{{data.value.batchStock ? data.value.batchStock : 0}}</span>          
        </template>
        <template v-slot:batchTotalCost="data">
          <span>{{displayPriceFormat(data.value.batchTotalCost)}}</span>
        </template>
        <template v-slot:totalCostInStock="data">
          <span>{{ data.value.totalStockCost ? displayPriceFormat(data.value.totalStockCost) : 0 }}</span>
        </template>
        <template v-slot:averageCost="data">
          <span>{{ displayPriceFormat(data.value.averageCost) }}</span>
        </template>
        <template v-slot:averageUnitCostInStock="data">
          <span>{{ data.value.productPricing?.cost ? displayPriceFormat(data.value.productPricing.cost) : ((data.value.inventorySnapshots?.[0]?.cost)?displayPriceFormat(data.value.inventorySnapshots[0].cost):0) }}</span>
        </template>
        <template v-slot:retailPrice="data">
          <span>{{ data.value.sale_price ? displayPriceFormat(data.value.sale_price) : 0 }}</span>
        </template>
        <template v-slot:profitMargin="data">
          <span>{{ data.value.profitMargin ? displayPriceFormat(data.value.profitMargin) : displayPriceFormat(0) }}</span>
        </template>
        <template v-slot:profitMarginPercentage="data">
          <span>{{ data.value.profit_margin_percentage ? data.value.profit_margin_percentage : 0 }}</span>
        </template>
        <template v-slot:markup="data">
          <span>{{ data.value.markup ? data.value.markup : 0 }}</span>
        </template>
        <template v-slot:firstReceivedOn="data">
          <span>{{ formatDate(data.value.inventoryAdjustment?.createdAt) }}</span>
        </template>
        <template v-slot:lotReceivedOn="data">
          <span>{{ formatDate(data.value.batchUploadDetails?.[0]?.createdAt) }}</span>
        </template>
        <template v-slot:createdAt="data">
          <span>{{ formatDate(data.value.inventorySnapshots?.[0]?.createdAt) }}</span>
        </template>
        </new-table-lite>
      </div>
    </div>
  </template>
  
  <script>
  import { defineComponent , ref} from "vue";
  import Env from '@/env';
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import StringHelpers from '@/helpers/string';
  import NewTableLite from '@/components/table/tableLite.vue'
  
  export default defineComponent({
    components: {
      NewTableLite
    },
    props: {
      filter: {
        type: Object,
        required: false
      },
      payload: {
        type: Array,
        required: false
      },
      sumPayload: {
        type: Object,
        required: false,
      },
      includeLot: {
        type: String,
        required: false
      },
      loaded: {
        type: Boolean,
        required: false
      }
    },
    setup() {
      const columnsLot = ref([
        {
          label: "Location Name",
          field: "location",
          sortable: false,
       },
       {
          label: "Product Name",
          field: "Name",
          sortable: false,
       },
       {
          label: "Product variant name",
          field: "variantName",
          sortable: false,
        },
        {
          label: "Brand",
          field: "brand",
          sortable: false,
        },
        {
          isKey:true,
          label: "Product Lot",
          field: "productLot",
          sortable: false,
          headerClasses:'width'
        },
        {
          label: "Category",
          field: "categoryName",
          sortable: false,
          headerClasses:'width'
        },
        {
          label: "Sub Category",
          field: "subCategoryName",
          sortable: false,
        },
        {
          label: "SKU",
          field: "sku",
          sortable: false,
  
        },
        {
          label: "Compliance Type",
          field: "complianceType",
          sortable: false,
        },
        {
          label: "Unit of measurement",
          field: "concentration_unit",
          sortable: false,
        },
        {
          label: "Stock",
          field: "stock",
          sortable: false,
        },
        {
          label: "Batch Stock",
          field: "batchStock",
          sortable: false,
        },
        {
          label: "Batch Total Cost",
          field: "batchTotalCost",
          sortable: false,
        },
        {
          label: "Total Cost In Stock",
          field: "totalCostInStock",
          sortable: false,
        },
        {
          label: "Average Unit Cost in Stock",
          field: "averageCost",
          sortable: false,
        },
        {
          label: "Retail Price",
          field: "retailPrice",
          sortable: false,
        },
        {
          label: "Profit Margin",
          field: "profitMargin",
          sortable: false,
        },
        {
          label: "Profit Margin Percentage",
          field: "profitMarginPercentage",
          sortable: false,
        },
        {
          label: "Profit Markup Percentage",
          field: "markup",
          sortable: false,
        },
        {
          label: "Lot Received On",
          field: "lotReceivedOn",
          sortable: false,
        },
        {
          label: "Created At",
          field: "createdAt",
          sortable: false,
        }
      ]);
  
      const columnProduct = ref([
        {
          label: "Location Name",
          field: "location",
          sortable: false,
       },
       {
          label: "Product Name",
          field: "Name",
          sortable: false,
       },
       {
          label: "Product variant name",
          field: "variantName",
          sortable: false,
        },
        {
          label: "Brand",
          field: "brand",
          sortable: false,
        },
        {
          label: "Category",
          field: "categoryName",
          sortable: false,
          headerClasses:'width'
        },
        {
          label: "Sub Category",
          field: "subCategoryName",
          sortable: false,
        },
        {
          label: "SKU",
          field: "sku",
          sortable: false,
        },
        {
          label: "Compliance Type",
          field: "complianceType",
          sortable: false,
        },
        {
          label: "Unit of measurement",
          field: "concentration_unit",
          sortable: false,
        },
        {
          label: "Stock",
          field: "stock",
          sortable: false,
        },
        {
          label: "Total Cost In Stock",
          field: "totalCostInStock",
          sortable: false,
        },
        {
          label: "Average Unit Cost in Stock",
          field: "averageUnitCostInStock",
          sortable: false,
        },
        {
          label: "Retail Price",
          field: "retailPrice",
          sortable: false,
        },
        {
          label: "Profit Margin",
          field: "profitMargin",
          sortable: false,
        },
        {
          label: "Profit Margin Percentage",
          field: "profit_margin_percentage",
          sortable: false,
        },
        {
          label: "Profit Markup Percentage",
          field: "markup",
          sortable: false,
        },
        {
          label: "First Received On",
          field: "firstReceivedOn",
          sortable: false,
        },
        {
          label: "Created At",
          field: "createdAt",
          sortable: false,
        }
      ]);
  
      const table = ref({
        isLoading: false,
        rows: [],
        totalRecordCount: 0,
        sortable: {
          order: "name",
          sort: "asc",
        },
        pagesize: Env.defaultPageSize,
        pageOptions: Env.pageList,
        count: 0,
        page: 1,
        
      });
      
      return  {
        table,
        columnsLot,
        columnProduct
      };
    },
  
    async mounted() {
       this.load()
       this.emitter.on('reloadSalesList', this.reload)
    },
    beforeDestroy() {
     this.emitter.off('reloadSalesList', this.reload)
    },
    computed: {
          ...mapGetters({
              vg_selectedLocation: 'location/selected'
          })
    },
    watch: {
      loaded(){
        this.load()
      }
    },
    methods: {
      displayPriceFormat(price) {
        return StringHelpers.roundOff(price, 2);
      },
      isCurrentDate(date){
        if(!date) return
        let defaultTimeZone = this.vg_selectedLocation.timezone?this.vg_selectedLocation.timezone:'America/Toronto';
        return moment(moment().tz(defaultTimeZone).format('YYYY-MM-DD')).isSame(date)
      },
      formatDate(date){
        if(!date) return ''
        let defaultTimeZone = this.vg_selectedLocation.timezone?this.vg_selectedLocation.timezone:'America/Toronto';
        return moment(date).tz(defaultTimeZone).format('YYYY-MM-DD hh:mm:ss A')
      },

      reload(){
        this.$nextTick(() => {
            this.load()
        })
      },
      selectColumnType(){
        if(this.includeLot){
          return this.columnsLot
        }else{
          return this.columnProduct
        }
      },
      async load(){
        this.table.isLoading = true
        this.table.rows = this.payload
        this.table.totalRecordCount = this.payload.length
        this.table.isLoading = false
      },
    }
  
  });
  </script>
  
  